// extracted by mini-css-extract-plugin
export default {"content":"content__KHZSx","message":"message__5TgIK","settings":"settings__RSYCA","network":"network__kbJhV","recycle-box":"recycle-box__ICrhS","warning":"warning__Ucjcs"};